import axios from "axios";
import { CONFIG_URL } from "./envConstants";

// axios configuration with api url
let instance = null;

if(process.env.REACT_APP_NODE_ENV && (process.env.REACT_APP_NODE_ENV === 'local' || process.env.REACT_APP_NODE_ENV === 'QA')) {
  instance = axios.create({
    baseURL: `${CONFIG_URL.apiUrl}/`,
  });
} else {
  instance = axios.create();
}

instance.interceptors.request.use(
  async (config) => {
    return config;
  }, (error) => {
    // Do Something with error
    console.log("ERROR", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    // Do Something after request
    const { status } = response;
    if (status === 200) {
      return response;
    }
  }, (error) => {
    const { message } = error;
    console.log("ERROR", message);
    return Promise.reject(error);
  }
);

export { instance };